import { useContext } from 'react';

import FormContext from '../../Context';
import * as S from './styles';
import { ContainerProps } from './types';

export const Container = ({ children }: ContainerProps) => {
  const { currentStep } = useContext(FormContext);

  const titles = {
    '1': 'Cadastre seu evento',
    '2': 'Escolha o tipo do evento',
    '3': 'Determine a data e hora de seu evento',
    '4': 'Configurações avançadas',
    '5': 'Resumo do evento'
  };
  return (
    <S.Wrapper>
      <S.Title>{titles[currentStep]}</S.Title>
      {children}
    </S.Wrapper>
  );
};
export default Container;
